// tslint:disable
export var configParticlesBuildingCelebrationBlue = {
    acceleration: {
        x: 0,
        y: 30,
    },
    addAtBack: false,
    alpha: {
        end: 0,
        start: 1,
    },
    angleStart: 0,
    blendMode: "add",
    color: {
        end: "#00a2ff",
        start: "#d4fbff",
    },
    emitterLifetime: 0.5,
    frequency: 0.001,
    lifetime: {
        max: 1.2,
        min: 1,
    },
    maxParticles: 20,
    maxSpeed: 100,
    noRotation: false,
    particleSpacing: 0,
    particlesPerWave: 15,
    pos: {
        x: 0,
        y: 0,
    },
    rotationSpeed: {
        max: 0,
        min: 0,
    },
    scale: {
        end: 0.05,
        minimumScaleMultiplier: 1,
        start: 0.15,
    },
    spawnType: "burst",
    speed: {
        end: -200,
        minimumSpeedMultiplier: 0.8,
        start: 300,
    },
    startRotation: {
        max: 0,
        min: 0,
    },
};
export var configParticlesBuildingCelebrationBlueGlow = {
    alpha: {
        start: 0.1,
        end: 0,
    },
    scale: {
        start: 5,
        end: 5,
        minimumScaleMultiplier: 1,
    },
    color: {
        start: "#00f2ff",
        end: "#00f2ff",
    },
    speed: {
        start: 0,
        end: 0,
        minimumSpeedMultiplier: 1,
    },
    acceleration: {
        x: 0,
        y: 10,
    },
    maxSpeed: 100,
    startRotation: {
        min: 0,
        max: 0,
    },
    noRotation: false,
    rotationSpeed: {
        min: 0,
        max: 0,
    },
    lifetime: {
        min: 0.8,
        max: 0.8,
    },
    blendMode: "add",
    frequency: 0.001,
    emitterLifetime: 0.2,
    maxParticles: 1,
    pos: {
        x: 0,
        y: 0,
    },
    addAtBack: false,
    spawnType: "burst",
    particlesPerWave: 1,
    particleSpacing: 0,
    angleStart: 0,
};



//////////////////
// WEBPACK FOOTER
// ./src/features/animation/particles/configParticlesBuildingCelebrationBlue.ts
// module id = 2146
// module chunks = 3